import React, { useEffect, useState } from "react";
import { Col, Form, Input, Modal, Row, Spin, Table, message } from "antd";
import styled from "styled-components";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { ButtonFilled } from "reusableComponent/UIButtons";

const StyledModal = styled(Modal)`
  .ant-form-item {
    margin-bottom: "12px";
  }
`;

function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const EditChargeOut = ({
  isEdit,
  setIsEdit,
  setRecordValue,
  loading,
  recordValue,
  handleFormSubmit,
  isLoading,
}) => {
  const [form] = Form.useForm();
  const [isView, setView] = useState();

  useEffect(() => {
    form.resetFields();
    setRecordValue({});
    const num = getRandomNumber(1, 10000);
    setView(num);
    form.setFieldsValue(recordValue);
    setRecordValue(recordValue);
  }, [isEdit, recordValue]);
  return (
    <Spin spinning={isLoading}>
      <StyledModal
        title="Edit Chargeout Rates"
        width={900}
        open={isEdit}
        footer={false}
        onCancel={() => {
          setRecordValue({});
          form.resetFields();
          setIsEdit(false);
        }}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFormSubmit}
          initialValues={
            Object.keys(recordValue).length ? recordValue : undefined
          }
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="jobgradecode" label="Job Grade Code">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="targetchargeability"
                label="Target Chargeability"
                rules={[
                  {
                    pattern: /^(100|[1-9]?[0-9])$/,
                    message: "Please enter a value between 0 and 100.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="standard"
                label="Standard"
                rules={[
                  {
                    pattern: /^[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid decimal value.",
                  },
                ]}
              >
                <Input
                  onKeyDown={(e) => {
                    const { key, target } = e;
                    const { value, selectionStart, selectionEnd } = target;
                    const allowedKeys = [
                      "Backspace",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                      "Home",
                      "End",
                    ];
                    if (allowedKeys.includes(key)) return;
                    if (!/[\d.]/.test(key)) {
                      e.preventDefault();
                      return;
                    }
                    if (key === "." && value.includes(".")) {
                      e.preventDefault();
                      return;
                    }
                    const dotIndex = value.indexOf(".");
                    if (
                      dotIndex !== -1 && // there's a decimal point
                      selectionStart > dotIndex && // cursor is after the decimal
                      value.substring(dotIndex + 1).length >= 2 && // already 2 digits after decimal
                      selectionStart === selectionEnd // no selection (typing)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="rate"
                label={`${recordValue?.country}`}
                rules={[
                  {
                    pattern: /^[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid decimal value.",
                  },
                ]}
              >
                <Input
                  onKeyDown={(e) => {
                    const { key, target } = e;
                    const { value, selectionStart, selectionEnd } = target;
                    const allowedKeys = [
                      "Backspace",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                      "Home",
                      "End",
                    ];
                    if (allowedKeys.includes(key)) return;
                    if (!/[\d.]/.test(key)) {
                      e.preventDefault();
                      return;
                    }
                    if (key === "." && value.includes(".")) {
                      e.preventDefault();
                      return;
                    }
                    const dotIndex = value.indexOf(".");
                    if (
                      dotIndex !== -1 && // there's a decimal point
                      selectionStart > dotIndex && // cursor is after the decimal
                      value.substring(dotIndex + 1).length >= 2 && // already 2 digits after decimal
                      selectionStart === selectionEnd // no selection (typing)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="w-100 text-end">
            <ButtonFilled
              className="text-end"
              htmlType="submit"
              loading={loading}
            >
              Save
            </ButtonFilled>
          </div>
        </Form>
      </StyledModal>
    </Spin>
  );
};
